import { useState, useEffect } from 'react';
import { getApp } from 'firebase/app';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import { todayIST } from '../../utils/reportCompilerUtils';

const S = {
  primary: '#65d4fa',
  mono: "'Share Tech Mono','Courier New',monospace",
};

export default function DailyLogFAB({ userId, onOpenComposer }) {
  const [hasPostedToday, setHasPostedToday] = useState(true);

  useEffect(() => {
    if (!userId) return;
    const db = getFirestore(getApp());
    const today = todayIST();
    getDocs(query(
      collection(db, 'daily_updates'),
      where('authorUid', '==', userId),
      where('date', '==', today),
    )).then(snap => {
      setHasPostedToday(snap.size > 0);
    }).catch(() => {});
  }, [userId]);

  return (
    <button
      onClick={onOpenComposer}
      title={hasPostedToday ? 'Post mission update' : 'No update posted today!'}
      style={{
        position: 'fixed', bottom: 28, right: 28, zIndex: 200,
        width: 52, height: 52, borderRadius: '50%',
        background: '#0d1526', border: `1.5px solid ${S.primary}`,
        cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: `0 0 18px ${S.primary}22`,
        transition: 'box-shadow 0.2s',
      }}
      onMouseEnter={e => e.currentTarget.style.boxShadow = `0 0 28px ${S.primary}55`}
      onMouseLeave={e => e.currentTarget.style.boxShadow = `0 0 18px ${S.primary}22`}
    >
      <span style={{ fontSize: 20, lineHeight: 1 }}>✏️</span>
      {!hasPostedToday && (
        <div style={{
          position: 'absolute', top: 6, right: 6,
          width: 10, height: 10, borderRadius: '50%',
          background: '#fbbf24',
          border: '1.5px solid #0d1526',
          boxShadow: '0 0 6px #fbbf24aa',
        }} />
      )}
    </button>
  );
}
